import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Button, message, Popconfirm } from 'antd'
import { IconBan, IconShieldOff } from '@tabler/icons-react'
import { useToken } from 'app/hooks'
import API from 'utils/api'

const IPContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const IPAddress = styled.span`
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  color: #333;
  flex: 1;
  text-align: left;
`

interface IPTextProps {
  ip: string
  mutate?: () => void
}

const IPText: React.FC<IPTextProps> = ({ ip, mutate }) => {
  const { data: token } = useToken()
  const [isBlocked, setIsBlocked] = useState(false)
  const [loading, setLoading] = useState(false)

  // IP 차단 상태 확인
  const checkIPStatus = async () => {
    if (!ip || !token) return

    try {
      const res = await API.get('/admin/ip', token + '', {})
      if (res?.result?.success && res?.result?.result) {
        const blockedIPs = res.result.result
        const blocked = blockedIPs.some((item: any) => item.ip === ip)
        setIsBlocked(blocked)
      }
    } catch (error) {
      console.log('IP 상태 확인 중 오류:', error)
    }
  }

  useEffect(() => {
    checkIPStatus()
  }, [ip, token])

  const handleBlockIP = () => {
    if (!ip) return
    setLoading(true)

    API.send('POST', '/admin/ip', token + '', {
      ip: ip
    }).then(res => {
      if (res?.result?.success) {
        message.success('IP가 차단되었습니다.')
        setIsBlocked(true)
        if (mutate) mutate()
      } else {
        message.error('IP 차단에 실패했습니다.')
      }
    }).catch(() => {
      message.error('IP 차단 중 오류가 발생했습니다.')
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleUnblockIP = () => {
    if (!ip) return
    setLoading(true)

    API.send('DELETE', '/admin/ip', token + '', {
      ip: ip
    }).then(res => {
      if (res?.result?.success) {
        message.success('IP 차단이 해제되었습니다.')
        setIsBlocked(false)
        if (mutate) mutate()
      } else {
        message.error('IP 차단 해제에 실패했습니다.')
      }
    }).catch(() => {
      message.error('IP 차단 해제 중 오류가 발생했습니다.')
    }).finally(() => {
      setLoading(false)
    })
  }

  return (
    <IPContainer>
      <IPAddress style={{ color: isBlocked ? '#ff4d4f' : '#333' }}>
        {ip} {isBlocked && '(차단됨)'}
      </IPAddress>
      {ip && (
        isBlocked ? (
          <Popconfirm
            title="IP 차단을 해제하시겠습니까?"
            onConfirm={handleUnblockIP}
            okText="해제"
            cancelText="취소"
          >
            <Button
              type="link"
              size="small"
              icon={<IconShieldOff size={14} />}
              loading={loading}
              style={{
                padding: '2px 4px',
                minWidth: 'auto',
                color: '#52c41a'
              }}
              title="IP 차단 해제"
            />
          </Popconfirm>
        ) : (
          <Button
            type="link"
            size="small"
            icon={<IconBan size={14} />}
            onClick={handleBlockIP}
            loading={loading}
            style={{
              padding: '2px 4px',
              minWidth: 'auto',
              color: '#ff4d4f'
            }}
            title="IP 차단"
          />
        )
      )}
    </IPContainer>
  )
}

export default IPText
